import Badge from "@atlaskit/badge";
import type {ComponentProps} from "react";

export function AnankeBadge(props: ComponentProps<typeof Badge>) {
    return <Badge {...props} />;
}
